import React, {Component} from 'react';
import {connect} from "react-redux";
import Modal from 'react-bootstrap/Modal'
import Loading from "../shared/Loading";

class QuestionModal extends Component {

    render() {
        return (
            <Modal
                style={{'overflow': 'auto'}}
                show={this.props.show}
                onHide={this.props.onHide}
                centered={true}
                size={"lg"}
                className="tutor-toast"
            >
                <div>
                    {this.props.children}
                </div>
                <div className="question-section text-center mb-5 mt-3">
                    <Loading show={this.props.hideButton}>
                        <button onClick={this.props.onReject}
                                className="waves-effect waves-light btn w-25 white no-uppercase shadow-white mr-3">
                            <span className="black-text">{this.props.rejectTitle}</span>
                        </button>
                        <button onClick={this.props.onAccept}
                                className="waves-effect waves-light btn w-25 white no-uppercase shadow-white">
                            <span className="black-text">{this.props.acceptTitle}</span>
                        </button>
                    </Loading>
                </div>

            </Modal>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionModal)
